import React from 'react'
import { Col, Form, Row } from 'react-bootstrap'
import { Controller, useFormContext } from 'react-hook-form'
import { ScorecardResult, Scorecard as ScorecardModel } from '../../../../../models/Scorecard'
import { getLabel, ScorecardLabelLevel } from '../../../../../common/clientProfile'

interface ScorecardPropertyProps {
  rootKeyName: string
  keyName: string
  scorecard: ScorecardModel
  scorecardResult: ScorecardResult
}

const NOT_SET = 'not set'

export const ScorecardProperty: React.FC<ScorecardPropertyProps> = ({ rootKeyName, keyName, scorecard, scorecardResult }) => {
  const { control, getValues } = useFormContext()

  const synchronizeArrays = (array1: Array<any>, array2: Array<any>) => {
    const allElements = Array.from(new Set([...array1, ...array2]))
    const synchronizedArray1 = allElements.map((element) => (array1.includes(element) ? element : NOT_SET))
    const synchronizedArray2 = allElements.map((element) => (array2.includes(element) ? element : NOT_SET))
    return [synchronizedArray1, synchronizedArray2]
  }

  const getPreviousValue = (key: string): string | string[] => {
    const newKey = '/' + key.replace('.', '/')
    if (scorecardResult.resultMetadata[newKey] && scorecardResult.resultMetadata[newKey]['previousValue']) {
      return scorecardResult.resultMetadata[newKey]['previousValue']
    }
    return NOT_SET
  }

  const key = `${rootKeyName}.${keyName}`
  const label = getLabel(scorecard.descriptor, key, getValues(), ScorecardLabelLevel.PROPERTY, scorecard.metadata)

  const renderOldArray = (key: string, value: Array<any>) => {
    const previousValueCandidate = getPreviousValue(key)
    let previousValue: Array<any> = []
    if (previousValueCandidate !== NOT_SET && Array.isArray(previousValueCandidate)) {
      previousValue = previousValueCandidate
    }
    const [oldValues, newValues] = synchronizeArrays(previousValue, value)
    return oldValues.map((value, index) => {
      return (
        <div className='d-flex align-items-center justify-content-center gap-3'>
          <div>
            <i className='bi bi-circle-fill' style={{ width: '0.5rem', height: '0.5rem', fontSize: '0.5rem' }} />
          </div>
          <Form.Control disabled={true} value={value} type='text' style={{ backgroundColor: 'lightgray' }} />
        </div>
      )
    })
  }

  const renderNewArray = (key: string, value: Array<any>) => {
    const previousValueCandidate = getPreviousValue(key)
    let previousValue: Array<any> = []
    if (previousValueCandidate !== NOT_SET && Array.isArray(previousValueCandidate)) {
      previousValue = previousValueCandidate
    }
    const [oldValues, newValues] = synchronizeArrays(previousValue, value)
    return newValues.map((value, index) => {
      return (
        <div className='d-flex align-items-center justify-content-center gap-3'>
          <div>
            <i className='bi bi-circle-fill' style={{ width: '0.5rem', height: '0.5rem', fontSize: '0.5rem' }} />
          </div>
          <Form.Control value={value} type='text' style={{ backgroundColor: 'white' }} />
        </div>
      )
    })
  }

  return (
    <Row className='py-3'>
      <Controller
        name={key}
        control={control}
        disabled={true}
        render={({ field }) => (
          <div className='d-flex gap-2'>
            <Col>
              <Form.Group className='mb-1' controlId={keyName}>
                <Form.Label className='text-capitalize'>{label}</Form.Label>
                <Col className='d-flex gap-2'>
                  <Col>
                    {!Array.isArray(getPreviousValue(key)) && !Array.isArray(field.value) ? (
                      <div className='d-flex'>
                        <Form.Control {...field} value={getPreviousValue(key)} type='text' style={{ backgroundColor: 'lightgray' }} />
                      </div>
                    ) : (
                      <div className='d-flex flex-column gap-2'>{Array.isArray(field.value) ? renderOldArray(key, field.value) : null}</div>
                    )}
                  </Col>
                  <Col className='d-flex justify-content-center align-items-center flex-grow-0'>
                    <i className='bi bi-arrow-right'></i>
                  </Col>
                  <Col>
                    {!Array.isArray(field.value) ? (
                      <div className='d-flex'>
                        <>
                          <Form.Control {...field} type='text' style={{ backgroundColor: 'white' }} />
                        </>
                      </div>
                    ) : (
                      <>
                        <div className='d-flex flex-column gap-2'>{renderNewArray(key, field.value)}</div>
                      </>
                    )}
                  </Col>
                </Col>
              </Form.Group>
            </Col>
          </div>
        )}
      />
    </Row>
  )
}
